import { useEffect } from 'react';

/**
 * This hook is used to automatically move the Intercom button to the bottom of the page when the HUD is opened.
 * This is a workaround for preventing Intercom from overlapping HUD.
 * TODO: Definitve solution is to use a Custom launcher for Intercom instead of using this CSS override
 */
export default function useAutoMoveIntercom(): void {
  useEffect(() => {
    document.body.classList.toggle('body-intercom-for-hud', true);

    return () => {
      document.body.classList.toggle('body-intercom-for-hud', false);
    };
  }, []);
}
